import { mediaQuery } from 'constants/ui';

export const getGroupStyles = ({ numberOfColumns, customStyles }) => ({
  display: 'grid',
  gap: '24px',
  gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`,

  ...customStyles,

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
    gap: '16px',
    ...customStyles?.[mediaQuery.mobile],
  },
  [mediaQuery.tablet]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
    ...customStyles?.[mediaQuery.tablet],
  },

  [`
    & .autocomplete-container[data-is-field-changed="true"] .MuiOutlinedInput-root:not(.Mui-error),
    & .text-field[data-is-field-changed="true"] .MuiOutlinedInput-root:not(.Mui-error),
    & .date-picker[data-is-field-changed="true"] .MuiOutlinedInput-root:not(.Mui-error)
  `]: {
    '& fieldset, &:hover fieldset, &.Mui-focused fieldset': {
      borderColor: ({ palette }) => palette.primary.main,
    },
  },
  [`
    & .checkbox[data-is-field-changed="true"]:not(.Mui-error),
    & .form-generator__checkbox-group-container .MuiCheckbox-root[data-is-field-changed="true"]:not([data-is-error="true"]),
    & .form-generator__radio-group[data-is-field-changed="true"]:not([data-is-error="true"]) .MuiRadio-root
  `]: {
    color: ({ palette }) => palette.primary.main,
  },
});
